import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const MODULE_1_BOOK = 'https://cdn.magicpatterns.com/uploads/xvwUuCxQzmu2tP6CaJh3Gy/Diseno_sin_titulo_(1).webp';
const MODULE_2_BOOK = 'https://cdn.magicpatterns.com/uploads/gcv1bjebstXw2HL8NKnQv1/Diseno_sin_titulo_(2)_(1).webp';
const MODULE_3_BOOK = 'https://cdn.magicpatterns.com/uploads/mJTvnR5dwGYD4UPtz75HKe/Diseno_sin_titulo_(3).webp';
const MODULE_4_BOOK = 'https://cdn.magicpatterns.com/uploads/iLaV5CYsLYu3wBtvomcJF3/Diseno_sin_titulo_(4).webp';
export function CurriculumSection() {
  return <section className="py-16 md:py-20 bg-[#4F7F53] w-full pt-[10px] pb-[10px] space-y-[12px]" data-id="element-88">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-89">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-white font-bold font-sans text-2xl md:text-3xl text-center mb-12 pt-[15px] pb-[15px]" data-id="element-90">
          En este E-BOOK encontrarás...
        </motion.h2>

        <div className="flex gap-16 flex-col items-start justify-start" data-id="element-91">
          {/* Module 1: Image Left, Card Right */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-92">
            <img src={MODULE_1_BOOK} alt="Fundamentos del Bubble Tea" width={600} height={800} loading="lazy" decoding="async" className="w-full md:w-[45%] h-auto drop-shadow-2xl object-contain" data-id="element-93" />
            <div className="w-full md:w-[55%] bg-white rounded-2xl p-8 shadow-lg" data-id="element-94">
              <h3 className="font-bold text-xl md:text-2xl text-[#3E2723] font-sans mb-4" data-id="element-95">
                Esenciales Bubble Tea
              </h3>
              <ul className="space-y-3" data-id="element-96">
                <li className="flex items-start gap-3" data-id="element-97">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-98">
                    <CheckIcon className="w-3 h-3 text-white" data-id="element-99" />
                  </div>
                  <span className="text-[#3E2723] text-sm md:text-base font-sans leading-relaxed" data-id="element-100">
                    La historia secreta detrás de esta bebida que conquistó el
                    mundo.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-101">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-102">
                    <CheckIcon className="w-3 h-3 text-white" data-id="element-103" />
                  </div>
                  <span className="text-[#3E2723] text-sm md:text-base font-sans leading-relaxed" data-id="element-104">
                    Ingredientes esenciales y herramientas que necesitas para
                    empezar.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-105">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-106">
                    <CheckIcon className="w-3 h-3 text-white" data-id="element-107" />
                  </div>
                  <span className="text-[#3E2723] text-sm md:text-base font-sans leading-relaxed" data-id="element-108">
                    Trucos y utensilios avanzados que elevarán tu nivel.
                  </span>
                </li>
              </ul>
            </div>
          </motion.div>

          {/* Module 2: Card Left, Image Right */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex flex-col md:flex-row-reverse items-center gap-8 md:gap-12" data-id="element-109">
            <img src={MODULE_2_BOOK} alt="La Base Perfecta" width={600} height={800} loading="lazy" decoding="async" className="w-full md:w-[45%] h-auto drop-shadow-2xl object-contain" data-id="element-110" />
            <div className="w-full md:w-[55%] bg-white rounded-2xl p-8 shadow-lg" data-id="element-111">
              <h3 className="font-bold text-xl md:text-2xl text-[#3E2723] font-sans mb-4" data-id="element-112">
                La Mezcla Perfecta
              </h3>
              <ul className="space-y-3" data-id="element-113">
                <li className="flex items-start gap-3" data-id="element-114">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-115">
                    <CheckIcon className="w-3 h-3 text-white" data-id="element-116" />
                  </div>
                  <span className="text-[#3E2723] text-sm md:text-base font-sans leading-relaxed" data-id="element-117">
                    Cómo preparar la infusión de té perfecta (verde, negro,
                    oolong).
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-118">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-119">
                    <CheckIcon className="w-3 h-3 text-white" data-id="element-120" />
                  </div>
                  <span className="text-[#3E2723] text-sm md:text-base font-sans leading-relaxed" data-id="element-121">
                    Errores comunes al hacer té y cómo evitarlos.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-122">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-123">
                    <CheckIcon className="w-3 h-3 text-white" data-id="element-124" />
                  </div>
                  <span className="text-[#3E2723] text-sm md:text-base font-sans leading-relaxed" data-id="element-125">
                    Las mejores leches y alternativas vegetales para un sabor
                    increíble.
                  </span>
                </li>
              </ul>
            </div>
          </motion.div>

          {/* Module 3: Image Left, Card Right */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-126">
            <img src={MODULE_3_BOOK} alt="Perlas de Tapioca" width={600} height={800} loading="lazy" decoding="async" className="w-full md:w-[45%] h-auto drop-shadow-2xl object-contain" data-id="element-127" />
            <div className="w-full md:w-[55%] bg-white rounded-2xl p-8 shadow-lg" data-id="element-128">
              <h3 className="font-bold text-xl md:text-2xl text-[#3E2723] font-sans mb-4" data-id="element-129">
                Perlas de Tapioca
              </h3>
              <ul className="space-y-3" data-id="element-130">
                <li className="flex items-start gap-3" data-id="element-131">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-132">
                    <CheckIcon className="w-3 h-3 text-white" data-id="element-133" />
                  </div>
                  <span className="text-[#3E2723] text-sm md:text-base font-sans leading-relaxed" data-id="element-134">
                    <strong data-id="element-135">¡Adiós perlas duras o sin sabor!</strong> Aprende a
                    hacerlas como un pro.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-136">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-137">
                    <CheckIcon className="w-3 h-3 text-white" data-id="element-138" />
                  </div>
                  <span className="text-[#3E2723] text-sm md:text-base font-sans leading-relaxed" data-id="element-139">
                    Perlas de matcha, chocolate, café, fresa, caramelo y más.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-140">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-141">
                    <CheckIcon className="w-3 h-3 text-white" data-id="element-142" />
                  </div>
                  <span className="text-[#3E2723] text-sm md:text-base font-sans leading-relaxed" data-id="element-143">
                    Cómo darle un toque único con sustitutos innovadores.
                  </span>
                </li>
              </ul>
            </div>
          </motion.div>

          {/* Module 4: Card Left, Image Right */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="flex flex-col md:flex-row-reverse items-center gap-8 md:gap-12" data-id="element-144">
            <img src={MODULE_4_BOOK} alt="Sabores Clasicos Reinventados" width={600} height={800} loading="lazy" decoding="async" className="w-full md:w-[45%] h-auto drop-shadow-2xl object-contain" data-id="element-145" />
            <div className="w-full md:w-[55%] bg-white rounded-2xl p-8 shadow-lg" data-id="element-146">
              <h3 className="font-bold text-xl md:text-2xl text-[#3E2723] font-sans mb-4" data-id="element-147">
                Gustos Clasicos Reinventados
              </h3>
              <ul className="space-y-3" data-id="element-148">
                <li className="flex items-start gap-3" data-id="element-149">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-150">
                    <CheckIcon className="w-3 h-3 text-white" data-id="element-151" />
                  </div>
                  <span className="text-[#3E2723] text-sm md:text-base font-sans leading-relaxed" data-id="element-152">
                    Recetas tradicionales con un giro inesperado.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-153">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-154">
                    <CheckIcon className="w-3 h-3 text-white" data-id="element-155" />
                  </div>
                  <span className="text-[#3E2723] text-sm md:text-base font-sans leading-relaxed" data-id="element-156">
                    <strong data-id="element-157">¿Bubble Tea de tamarindo y chile?</strong> Sí, y
                    muchos más sabores exóticos.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-158">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-159">
                    <CheckIcon className="w-3 h-3 text-white" data-id="element-160" />
                  </div>
                  <span className="text-[#3E2723] text-sm md:text-base font-sans leading-relaxed" data-id="element-161">
                    Combos irresistibles con lavanda, jazmín, lichi y más.
                  </span>
                </li>
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}